import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
import {DatePipe} from '@angular/common';

@Pipe({
    name: 'ngcExpireDate'
})
export class ExpireDatePipe implements PipeTransform {


    transform(expirationTs: Date, isExpired: boolean = false): string {
        const expirationDateDifference = moment(expirationTs).diff(new Date(), 'days', true);

        switch (true) {
            case (expirationDateDifference < -1 && isExpired || expirationDateDifference > 2 && !isExpired):
                return moment(expirationTs).fromNow();

            case (expirationDateDifference >= 0 && expirationDateDifference <= 2):
                return  moment(expirationTs).calendar(null, {
                    sameDay: '[today]',
                    nextDay: '[tomorrow]',
                    lastDay: 'shortDate',
                    sameElse: 'shortDate'
                });

            case (expirationDateDifference >= -1 && expirationDateDifference < 0 && isExpired):
                return  moment(expirationTs).calendar(null, {
                    sameDay: '[today]',
                    lastDay: '[a day ago]',
                    sameElse: 'shortDate'
                });

            default:
                return new DatePipe('en').transform(expirationTs, 'shortDate');
        }
    }
}
